import React from 'react';
import './courseKit.css';

export const TRUSTPILOT_URL = 'https://www.trustpilot.com/review/lumiwealth.com';

const Star = ({ fill, id }) => (
  <svg className="ck-star" viewBox="0 0 20 20" aria-hidden="true" focusable="false">
    <defs>
      <linearGradient id={id}>
        <stop offset={`${fill * 100}%`} stopColor="currentColor" />
        <stop offset={`${fill * 100}%`} stopColor="transparent" stopOpacity="0" />
      </linearGradient>
    </defs>
    <path
      d="M10 1.6l2.6 5.3 5.8.8-4.2 4.1 1 5.8-5.2-2.7-5.2 2.7 1-5.8L1.6 7.7l5.8-.8z"
      fill={`url(#${id})`}
      stroke="currentColor"
      strokeWidth="1"
      strokeLinejoin="round"
    />
  </svg>
);

/**
 * Trustpilot rating with real star graphics and a link to the public profile.
 * Deliberately shows no review year: dating a quote makes it read as stale.
 */
const StarRating = ({ rating = 4.6, count, showLink = true, compact = false }) => {
  const stars = [0, 1, 2, 3, 4].map((i) => Math.max(0, Math.min(1, rating - i)));

  return (
    <div className={`ck-rating ${compact ? 'is-compact' : ''}`.trim()}>
      <span className="ck-stars" role="img" aria-label={`${rating} out of 5 stars`}>
        {stars.map((fill, i) => (
          <Star key={i} fill={fill} id={`ck-star-${i}-${Math.round(fill * 100)}`} />
        ))}
      </span>
      <span className="ck-rating-value">{rating}</span>
      {showLink ? (
        <a className="ck-rating-link" href={TRUSTPILOT_URL} target="_blank" rel="noopener noreferrer">
          on Trustpilot{count ? ` (${count} reviews)` : ''}
        </a>
      ) : (
        <span className="ck-rating-label">on Trustpilot{count ? ` (${count} reviews)` : ''}</span>
      )}
    </div>
  );
};

export default StarRating;
